<div class="card">
    <div class="icon" [innerHTML]="icon()"></div>
    <div class="value-container">
        <div class="value">
            <span>
                {{ formatValue() }}
            </span>
        </div>
        <div class="label">
            {{ titleValue() }}
        </div>
    </div>
</div>
